export default __webpack_public_path__ + "static/media/Next-blue.39a32a68.svg";